// Libraries
import React from 'react';
import {Row, Form, Modal, Switch} from 'antd';
import {useAppDispatch} from '../../store/store';

// Store
import { create, update } from '../../store/redux/actions/locationActions';

// Types
import {LocationType} from "../../types/locationTypes";

// Components
import ButtonComponent from '../subComponents/ButtonComponent';
import FormItemComponent from '../subComponents/FormItemComponent';
import InputComponent from '../subComponents/InputComponent';


type PropsType = {
  isEditing?: boolean;
  locationToEdit?: LocationType;
  onToggleModal: (visible: boolean) => void;
};
const LocationsFormModal = (props: PropsType) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { isEditing, locationToEdit, onToggleModal } = props;

  const handleSubmit = (location: LocationType) => {
    if(isEditing){
      location.locationId = locationToEdit!.locationId;

      dispatch(update(location));
    } else {
      dispatch(create(location));
    }
    onToggleModal(false);
  }

  return (
    <Modal title={`${isEditing ? 'Editar' : 'Crear'} ubicación`}
           open={true} maskClosable closable={false} keyboard={false} destroyOnClose={true}
           footer={[
             <ButtonComponent key={'cancel'} text={'Cerrar'}
                              className={'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
                                'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'}
                              onClick={() => onToggleModal(false)} />,
             <ButtonComponent key={'submit'} text={`${isEditing ? 'Editar' : 'Crear'}`}
                              className={'w-32 h-8 text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                                'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                              onClick = {() => form.submit()}/>,
           ]}>
      <Form layout={"vertical"}
            form={form}
            initialValues={locationToEdit ?? {}}
            onFinish={handleSubmit}>
        <Row className={'grid grid-cols-1 md:grid-cols-2 gap-x-2'}>
          {isEditing &&
            <FormItemComponent name={'isActive'}
                               className={'col-span-2'}
                               label={''}
                               required={false}
                               valuePropName={'checked'}
                               child={<Switch checkedChildren={"Activa"}
                                              unCheckedChildren={"Inactiva"} />}
            />
          }

          <FormItemComponent name={'zipCode'}
                             label={'Código Postal'}
                             required={true}
                             child={<InputComponent />}
          />

          <FormItemComponent name={'daneCode'}
                             label={'Código Dane'}
                             required={true}
                             child={<InputComponent />}
          />

          <FormItemComponent name={'coordinadoraCode'}
                             label={'Código Coordinadora'}
                             required={true}
                             child={<InputComponent />}
          />
        </Row>
      </Form>
    </Modal>
  );
}

export default LocationsFormModal;